/**
 * @namespace Gallery
 * @aka SWR.Gallery
 *
 */
SWR.Gallery = (function ($) {
  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */
  var NAME = 'gallery';
  var DATA_KEY = 'swr.' + NAME;
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];
  var Event = {
    PJAX_DATA_API: 'pjax:end' + EVENT_KEY + DATA_API_KEY
  };
  var Selector = {
    DATA_SPY: '[data-spy="gallery"]'
  };
  var Default = {
    currentSlide: 0,
    slidesToShow: 1
  };
  var DefaultType = {
    currentSlide: 'number',
    slidesToShow: 'number'
  };

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */
  var Gallery = function () {
    function Gallery(element, config) {
      COMMON.Utils._classCallCheck(this, Gallery);
      var self = this;
      /**
       * @protected
       */
      self.element = element;
      self.$element = $(self.element);
      self.config = self._getConfig(config);
      var $element = $(self.element);
      SWR.Utils.destroySlick($element);

      /******************
       * UUID an einzelne Galerien hängen
       */
      var uuid = COMMON.Utils.uuid();
      self.element.id = uuid;

      var fullscreenTarget = '#' + uuid;

      var fullscreenTemplate = '  <button class="fullscreen-btn" data-toggle="fullscreen" data-target="{fullscreenTarget}">' +
        '<i class="icon-zoom"></i>' +
        '<span class="sr-only">Bild in Detailansicht öffnen</span>' +
        '</button>';

      $element.on('init', function (event, slick) {
        if (slick.slideCount > 0) {
          self.$element.find(".slick-slide figcaption").append(COMMON.Utils.template(fullscreenTemplate, {fullscreenTarget: fullscreenTarget}));
          $element.find('.fullscreen-btn, .slick-arrow, figcaption, .info').addClass('fadeout');

          self.$element.find(".slick-slide figure.figure-svg").each(function () {
            $(this).css("display", "flex");
          });
        }
      });

      /***********************
       * Ermittlung von URL-Parametern
       */
      self._getParams();

      $element.on('swipe', function(event, slick, direction) {
        try {
        if (direction === 'left') {
          PIANO.UsabilityClick.usabilityClickEvent({
            'type': 'action',
            'click': 'Es wurde zum nächsten Bild geblättert',
            'click_chapter1': 'Bildergalerie',
            'click_chapter3': self.$element.find('.slick-track .slick-active figure').attr('itemid')
          });
        } else {
          PIANO.UsabilityClick.usabilityClickEvent({
            'type': 'action',
            'click': 'Es wurde zum vorherigen Bild geblättert',
            'click_chapter1': 'Bildergalerie',
            'click_chapter3': self.$element.find('.slick-track .slick-active figure').attr('itemid')
          });
        }
        } catch (e) {
          console.warn(e);
        }
      });

      $element.on('click', '.slick-prev', function(){
        //Vorheriges Bild
        //PIANO-Usability-Click senden
        try {
          PIANO.UsabilityClick.usabilityClickEvent({
            'type': 'action',
            'click': 'Es wurde zum vorherigen Bild geblättert',
            'click_chapter1': 'Bildergalerie',
            'click_chapter3': self.$element.find('.slick-track .slick-active figure').attr('itemid')
          });
        } catch (e) {
          console.log(e);
        }
      });

      $element.on('click', '.slick-next', function(){
        //Nächstes Bild
        //PIANO-Usability-Click senden
        try {
          PIANO.UsabilityClick.usabilityClickEvent({
            'type': 'action',
            'click': 'Es wurde zum nächsten Bild geblättert',
            'click_chapter1': 'Bildergalerie',
            'click_chapter3': self.$element.find('.slick-track .slick-active figure').attr('itemid')
          });
        } catch (e) {
          console.warn(e);
        }
      });

      $element.on('beforeChange' + EVENT_KEY, function (event, slick, currentSlide, nextSlide) {
        $(document).trigger('common:pixel:pageview');
      });

      $element.on('init afterChange', function (event, slick) {
        self._lazyLoad(slick);
      });

      $element.on('click', function (event) {
        try {
        if($(event.target).is('img')) {
          $element.slick('slickNext');
          PIANO.UsabilityClick.usabilityClickEvent({
            'type': 'action',
            'click': 'Es wurde zum nächsten Bild geblättert',
            'click_chapter1': 'Bildergalerie',
            'click_chapter3': self.$element.find('.slick-track .slick-active figure').attr('itemid')
          });
        }
        } catch (e) {
          console.warn(e);
        }

        // Reload animation: https://css-tricks.com/restart-css-animation/
        $element.find('.fullscreen-btn, .slick-arrow, figcaption, .info').removeClass('fadeout');
        void element.offsetWidth;
        $element.find('.fullscreen-btn, .slick-arrow, figcaption, .info').addClass('fadeout');
      });

      /******************
       * FULLSCREEN-Button
       */

      $element.on('click', '.fullscreen-btn', function () {
        try {
        if(!$(this).closest('.mediagallery-items').hasClass('fullscreen')) {
          //Fullscreen ist noch nicht aktiv
          //PIANO-Usability-Click senden
          PIANO.UsabilityClick.usabilityClickEvent({
            'type': 'action',
            'click': 'Es wurde der Vollbildmodus gewählt',
            'click_chapter1': 'Bildergalerie',
            'click_chapter3': self.$element.find('.slick-track .slick-active figure').attr('itemid')
          });
        } else {
          //Fullscreen wird geschlossen
          //PIANO-Usability-Click senden
          PIANO.UsabilityClick.usabilityClickEvent({
            'type': 'action',
            'click': 'Es wurde der Vollbildmodus geschlossen',
            'click_chapter1': 'Bildergalerie',
            'click_chapter3': self.$element.find('.slick-track .slick-active figure').attr('itemid')
          });
        }
        } catch (e) {
          console.warn(e);
        }

        $(fullscreenTarget).toggleClass('fullscreen');

        // Remove and re-insert fullscreen button, so that slick('refresh') works properly
        $element.find('.fullscreen-btn').remove();

        $element.slick('refresh');
        self.$element.find(".slick-slide figcaption").append(COMMON.Utils.template(fullscreenTemplate, {fullscreenTarget: fullscreenTarget}));
      });

      $element.on('webkitfullscreenchange mozfullscreenchange fullscreenchange MSFullscreenChange', function (e) {
        var isFullscreen = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement;
        if(isFullscreen){
          $(fullscreenTarget).addClass('fullscreen');
        } else {
          $(fullscreenTarget).removeClass('fullscreen');
          $element.slick('refresh');
        }
      });

      /***********************
       * Ende Fullscreen
       */


      /***********************
       * Erstellen der Bildergalerie
       */
      $element.slick({
        // normal options...
        rtl: 'rtl' === $('html').prop('dir').toLowerCase(),
        slidesToShow: this.config.slidesToShow,
        lazyLoad: 'anticipated', // must be 'anticipated'
        mobileFirst: true,
        infinite: true,
        speed: 214,
        initialSlide: (self.urlParams.has('currentSlide') ? self.urlParams.get('currentSlide') - 1 : this.config.currentSlide),
        adaptiveHeight: false,
        swipeToSlide: true,
        dots: true,
        customPaging: function (slider, i) {
          var currentSlide = (i + 1),
            totalSlides = slider.slideCount;
          return COMMON.Utils.template('<p class="info"><span class="sr-only">Bild </span>{currentSlide}<span class="info-divider" aria-hidden="true"></span><span class="sr-only"> von </span>{totalSlides}</p>', {
            currentSlide: currentSlide,
            totalSlides: totalSlides
          });
        }
      });

      //self._setWidth();

      $(document).one('pjax:beforeReplace', function () {
        try {
          $element.slick('unslick')
        } catch (e) {
        }
      });
    }

    Gallery.prototype._getParams = function _getParams(){
      var self = this;
      if(window.URLSearchParams){
        self.urlParams = new URLSearchParams(window.location.search);
      } else {
        window.URLSearchParams = function URLSearchParams() {
          this.params = {};
        };
        window.URLSearchParams.prototype = {
          set: function (key, value) {
            this.params[key] = value;
          },
          get: function (key) {
            return this.params[key];
          },
          has: function (key) {
            return this.params.hasOwnProperty(key);
          },
          delete: function (key) {
            delete this.params[key];
          },
          toString: function () {
            return Object.keys(this.params).map(function (param) {
              return param + '=' + encodeURIComponent(this.params[param]);
            }, this).join('&');
          },
        };
        self.urlParams = new URLSearchParams(window.location.search);
      }
    };


    // https://jira.ard.de/browse/SWRONL-3714
    // Skalierung kleiner Bilder wird unterbunden, wenn die Redaktion
    // nur kleine Bilder für die Galerie hochgeladen hat.
    // Da "srcset" automatisch skaliert und dies nicht per CSS unterbunden werden kann,
    // arbeitet das Skript mit Magic Numbers.
    // Die Maximalbreite ist so gesetzt, dass ganz kleine Bilder leicht skaliert werden,
    // was aber der Qualität normalerweise keinen Abbruch tut. (JG)
    Gallery.prototype._setWidth = function _setWidth(){
      var self = this;
      $(self.$element.find('.slick-list figure img')).each(function () {
        var mImg = this;
        var mImgSrc = $(mImg).attr('srcset');
        if (mImgSrc.indexOf("320w") > -1 || mImgSrc.indexOf("480w") > -1) {
          if(!(mImgSrc.indexOf("768w") > -1 && mImgSrc.indexOf("1024w") > -1 && mImgSrc.indexOf("1080w") > -1)) {
            $(mImg).parent().css("display", "flex").css("justify-content", "center");
            $(mImg).css("width", "auto").css("max-width", "480px").css("margin", "0");
          }
        }
      });
    };
    // private
    Gallery.prototype._getConfig = function _getConfig(config) {
      config = $.extend({}, Default, config);
      COMMON.Utils.typeCheckConfig(NAME, config, DefaultType);
      return config;
    };

    /**
     * CMSNEU-2095
     *
     * @param slick
     * @private
     */
    Gallery.prototype._lazyLoad = function _lazyLoad(slick) {
      var _ = slick,
        loadRange, cloneRange, rangeStart, rangeEnd;
      function loadImages(imagesScope) {
        imagesScope.find('img').attr('loading' , 'eager');
      }
      if (_.options.centerMode === true) {
        if (_.options.infinite === true) {
          rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
          rangeEnd = rangeStart + _.options.slidesToShow + 2;
        } else {
          rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
          rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
        }
      } else {
        rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
        rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
        if (_.options.fade === true) {
          if (rangeStart > 0) rangeStart--;
          if (rangeEnd <= _.slideCount) rangeEnd++;
        }
      }
      loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);
      if (_.options.lazyLoad === 'anticipated') {
        var prevSlide = rangeStart - 1,
          nextSlide = rangeEnd,
          $slides = _.$slider.find('.slick-slide');
        for (var i = 0; i < _.options.slidesToScroll; i++) {
          if (prevSlide < 0) prevSlide = _.slideCount - 1;
          loadRange = loadRange.add($slides.eq(prevSlide));
          loadRange = loadRange.add($slides.eq(nextSlide));
          prevSlide--;
          nextSlide++;
        }
      }
      loadImages(loadRange);
      if (_.slideCount <= _.options.slidesToShow) {
        cloneRange = _.$slider.find('.slick-slide');
        loadImages(cloneRange);
      } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
        cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
        loadImages(cloneRange);
      } else if (_.currentSlide === 0) {
        cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
        loadImages(cloneRange);
      }
    };
    // public
    Gallery.prototype.dispose = function dispose() {
      $(this.element).off(EVENT_KEY);
      $(this.element).slick('unslick');
      this.element = null;
    };
    // static
    Gallery._jQueryInterface = function _jQueryInterface() {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);
        var _config = $.extend({}, Default, $(this).data());
        if ((typeof config === 'undefined' ? 'undefined' : COMMON.Utils._typeof(config)) === 'object') {
          $.extend(_config, config);
        }
        if (!data) {
          data = new Gallery(this, _config);
          $(this).data(DATA_KEY, data);
        }
        if (typeof config === 'string') {
          if (data[config] === undefined) {
            throw new Error('No method named ' + config + '');
          }
          data[config]();
        }
      });
    };
    return Gallery;
  }();
  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */
  $(document).on(Event.PJAX_DATA_API, function (event, xhr, options) {
    $(options.container).find(Selector.DATA_SPY).each(function () {
      var $gallery = $(this);
      Gallery._jQueryInterface.call($gallery);
    });
  });
  $(Selector.DATA_SPY).each(function () {
    var $gallery = $(this);
    Gallery._jQueryInterface.call($gallery);
  });
  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */
  $.fn[NAME] = Gallery._jQueryInterface;
  $.fn[NAME].Constructor = Gallery;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Gallery._jQueryInterface;
  };
  return Gallery;
})(window.jQuery);
